import { useEffect } from 'react';

const SEOHead = ({ title, description, canonical, ogImage, ogType = 'website', article = null, jsonLd = null }) => {
  const siteName = 'Nerava';
  const defaultImage = 'https://nerava.id/og-image.png';
  const img = ogImage || defaultImage;

  useEffect(() => {
    // Title
    document.title = title;

    // Helper to set/create meta tag
    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // Helper to set/create link tag
    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    // Description & Keywords
    setMeta('name', 'description', description);
    if (article?.keywords) setMeta('name', 'keywords', article.keywords);

    // Canonical
    setLink('canonical', canonical);

    // Open Graph
    setMeta('property', 'og:type', ogType);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', img);
    setMeta('property', 'og:url', canonical);
    setMeta('property', 'og:site_name', siteName);
    setMeta('property', 'og:locale', 'id_ID');

    // Twitter Card
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', img);

    // Article specific
    if (article?.date) setMeta('property', 'article:published_time', article.date);
    if (article?.category) setMeta('property', 'article:section', article.category);

    // JSON-LD
    let jsonLdEl = document.querySelector('script[data-seo-jsonld]');
    if (jsonLd) {
      if (!jsonLdEl) {
        jsonLdEl = document.createElement('script');
        jsonLdEl.setAttribute('type', 'application/ld+json');
        jsonLdEl.setAttribute('data-seo-jsonld', 'true');
        document.head.appendChild(jsonLdEl);
      }
      jsonLdEl.textContent = JSON.stringify(jsonLd);
    } else if (jsonLdEl) {
      jsonLdEl.remove();
    }

    // Cleanup on unmount - restore defaults
    return () => {
      document.title = 'Nerava: AI Customer Service & CRM Omnichannel untuk Toko Online';
      setMeta('name', 'description', 'AI customer assistant Nerava membalas chat WhatsApp, Instagram & Messenger 24 jam: jawab harga dan stok, kirim foto produk, hitung ongkir, sampai pesanan masuk. Coba gratis 30 hari, tanpa kartu kredit.');
      setLink('canonical', 'https://nerava.id');
      setMeta('property', 'og:type', 'website');
      setMeta('property', 'og:title', 'Nerava: AI Customer Service & CRM Omnichannel untuk Toko Online');
      setMeta('property', 'og:description', 'AI membalas chat WhatsApp, Instagram & Messenger 24 jam: jawab harga dan stok, kirim foto produk, hitung ongkir, sampai pesanan masuk. Coba gratis 30 hari.');
      setMeta('property', 'og:image', defaultImage);
      setMeta('property', 'og:url', 'https://nerava.id');
      // Remove article-specific tags
      document.querySelector('meta[property="article:published_time"]')?.remove();
      document.querySelector('meta[property="article:section"]')?.remove();
      if (jsonLdEl) jsonLdEl.remove();
    };
  }, [title, description, canonical, ogImage, ogType, article, jsonLd, img]);

  return null;
};

export default SEOHead;
